var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AvatarWithLabel } from 'modules/v2/dataDisplay/AvatarWithLabel';
import { IconWithLabel } from 'modules/v2/dataDisplay/IconWithLabel';
import { Box } from 'modules/v2/foundation/Box';
const avatarSizes = {
    small: 'lg',
    medium: '2xl',
};
export function EmptyState(props) {
    const { icon, title, description, actions, className, size = 'medium', withAvatar, px = 'md' } = props, rest = __rest(props, ["icon", "title", "description", "actions", "className", "size", "withAvatar", "px"]);
    const flexDirection = size === 'small' ? 'column' : 'row';
    const gap = size === 'small' ? 'lg' : 'xl';
    return (<Box className={className} flexDirection="column" alignItems="center" justifyContent="center" gap="3xl" py="7xl" px={px} {...rest}>
      {withAvatar ? (<AvatarWithLabel alignment="vertical" appearance="secondary" size={avatarSizes[size]} title={title} subtitle={description} truncate={false}>
          {icon}
        </AvatarWithLabel>) : (<IconWithLabel alignment="vertical" size={avatarSizes[size]} title={title} subtitle={description} truncate={false}>
          {icon}
        </IconWithLabel>)}
      {actions && (<Box flexDirection={flexDirection} gap={gap}>
          {actions}
        </Box>)}
    </Box>);
}
